var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5713 24.3951C23.109 24.3951 22.7343 24.0204 22.7343 23.5581C22.7343 23.0959 23.109 22.7212 23.5713 22.7212",
    stroke: "#CE0707",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5712 24.3951C24.0335 24.3951 24.4082 24.0204 24.4082 23.5581C24.4082 23.0959 24.0335 22.7212 23.5712 22.7212",
    stroke: "#CE0707",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3647 24.3951C13.9025 24.3951 13.5278 24.0204 13.5278 23.5581C13.5278 23.0959 13.9025 22.7212 14.3647 22.7212",
    stroke: "#CE0707",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3647 24.3951C14.827 24.3951 15.2017 24.0204 15.2017 23.5581C15.2017 23.0959 14.827 22.7212 14.3647 22.7212",
    stroke: "#CE0707",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7778 24.3951C32.3155 24.3951 31.9408 24.0204 31.9408 23.5581C31.9408 23.0959 32.3155 22.7212 32.7778 22.7212",
    stroke: "#CE0707",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7778 24.3951C33.24 24.3951 33.6149 24.0204 33.6149 23.5581C33.6149 23.0959 33.24 22.7212 32.7778 22.7212",
    stroke: "#CE0707",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5585 2C19.6589 2.00122 15.8326 3.06015 12.4872 5.06401C9.1418 7.06788 6.40258 9.94162 4.56127 13.3792C2.71996 16.8167 1.84554 20.6893 2.03114 24.5845C2.21673 28.4798 3.4554 32.2517 5.6152 35.4985L2 45.1172L14.1059 42.928C17.021 44.3525 20.22 45.1008 23.4645 45.1168C26.7089 45.1329 29.9152 44.4165 32.8442 43.0208C35.7732 41.6254 38.3497 39.5866 40.3808 37.0566C42.4123 34.527 43.8468 31.5712 44.5767 28.4099C45.3068 25.2486 45.3142 21.9633 44.5978 18.7988C43.8813 15.6344 42.4602 12.6724 40.4398 10.1338C38.4193 7.59506 35.8519 5.54519 32.929 4.13686C30.0061 2.72852 26.803 1.99809 23.5585 2Z",
    stroke: "#CE0707",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/supportIcon.76e8e7afe42abb76ed8c40a233dba8e5.svg";
export { ForwardRef as ReactComponent };